export const AUTH_TOKEN = 'sentry-meet-token';
export const RENEWAL_TOKEN = 'sentry-REPLACE_ME-r-token';
export const VUEX_STORE = 'sentry-s-store';
export const MEETING_INFO = 'sentry-meeting-info';
export const LANG = 'lang';

export const EXCLUDE_KEYS = ['notification'];
